module.exports = __webpack_public_path__ + "fonts/Fortescue-Regular.e0b3e17c15755f9dda1a5eda3ed62737.ttf";